module.exports = __webpack_public_path__ + "static/media/ic_arrow_more.b23a595c.svg";